import React, { useRef, useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { Formik, Form } from "formik";
import { connect } from "react-redux";
import BarcodeReader from "react-barcode-reader";

import {
  buttonNameConstants,
  customerConstants,
  defaultGridState,
  EMPTY_STRING,
} from "../../../../constants";
import { addCustomerValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import {
  customerActions,
  logErrorsActions,
  transactionActions,
} from "../../../../redux/actions";
import ScanIdModal from "../../../Customers/CustomerModals/ScanIdModal";
import { getIsShowCustomerScanButton } from "../../../../shared/utility";
import CustomerCreditAndSubmitButtons from "./CustomerCreditAndSubmitButtons";
import {
  getCountryByStateName,
  handleScan,
} from "../../../../shared/utilities/customersUtility";
import {
  Button,
  SelectField,
  InputTextArea,
  InputTextField,
  SelectFieldCity,
  PersonalInformation,
} from "../../../../shared/components";

const AddNewCustomerModal = (props) => {
  const {
    user,
    store,
    logErrors,
    updateCustomer,
    customerToEdit,
    addNewCustomer,
    addCustomerModal,
    toggleAddCustomerModal,
    transferCustomerCredit,
    selectedCustomer = () => {},
    isTransferCustomerCreditModal,
    shopifyOrdersCallBackConfig = {
      // If renders through shopify orders then set details to refetch/update orders after adding/updating new customer as we want to show updated customer in order modal and auto attach the customer with order
      isRefetchOrdersOnSave: false,
      gridState: defaultGridState,
      callBackFuction: () => {},
      isRefetchTransactionsOnSave: false,
    },
  } = props;

  const { currentStore } = store;
  const formikRef = useRef();

  const initialValues = {
    firstName: customerToEdit?.firstName || EMPTY_STRING,
    lastName: customerToEdit?.lastName || EMPTY_STRING,
    email: customerToEdit?.email || EMPTY_STRING,
    mobile: customerToEdit?.mobile || EMPTY_STRING,
    driverLicense: customerToEdit?.driverLicense || EMPTY_STRING,
    line1: customerToEdit?.line1 || EMPTY_STRING,
    line2: customerToEdit?.line2 || EMPTY_STRING,
    city: customerToEdit?.city || EMPTY_STRING,
    state: customerToEdit?.state || EMPTY_STRING,
    zip: customerToEdit?.zip || EMPTY_STRING,
    currentBalance: customerToEdit?.currentBalance || 0,
    isSmsAlert: customerToEdit?.isSmsAlert || false,
    isEmailAlert: customerToEdit?.isEmailAlert || false,
    productNotification: customerToEdit?.productNotification || [],
    companyCustomerId: customerToEdit?.companyCustomerId || 0,
    note: customerToEdit?.note || EMPTY_STRING,
    driverLicenseIdType:
      customerToEdit?.driverLicenseIdType ||
      customerConstants.ID_TYPES[0].value,
    expirationDate: customerToEdit?.expirationDate
      ? customerToEdit?.expirationDate
      : null,
    dateOfBirth: customerToEdit?.dateOfBirth || null,
  };

  const [isScanning, setIsScanning] = useState(false);
  const [isShowScanButton, setIsShowScanButton] = useState(
    getIsShowCustomerScanButton(customerToEdit?.driverLicenseIdType)
  );

  const toggleScanningModal = () => {
    setIsScanning(!isScanning);
  };

  const handleHideModal = () => {
    toggleAddCustomerModal(false);
  };

  const handleSubmit = (data) => {
    selectedCustomer(true);
    const country = getCountryByStateName(data.state);
    if (customerToEdit?.id) {
      updateCustomer({
        ...data,
        id: customerToEdit?.id,
        store: {
          id: currentStore?.id,
          name: currentStore?.storeName,
        },
        companyId: currentStore?.companyId,
        countryCode: country?.isoCode || EMPTY_STRING,
        shopifyOrdersCallBackConfig,
      });
    } else {
      if (isTransferCustomerCreditModal) {
        //it is true in case of guest customer -> transfer -> addNewCustomer (and only in this case customerToEdit has guestCustomer object) otherwise it is false and there is no guestCustomer=undefined in customerToEdit
        transferCustomerCredit({
          fromId: customerToEdit.selectedGuestCustomer.id,
          toId: EMPTY_STRING,
          isResetBalanceOfFrom: true,
          balanceToTransfer: 0,
          companyId: currentStore.companyId,
          store: {
            id: currentStore.id,
            name: currentStore.storeName,
          },
        });
      }
      addNewCustomer({
        ...data,
        store: {
          id: currentStore?.id,
          name: currentStore?.storeName,
        },
        companyId: currentStore?.companyId,
        countryCode: country?.isoCode || EMPTY_STRING,
        shopifyOrdersCallBackConfig,
      });
    }
  };

  const handleError = () => {};

  return (
    <>
      {isScanning && (
        <div>
          <BarcodeReader
            onError={handleError}
            onScan={(scannedData) => {
              handleScan({
                user,
                formikRef,
                logErrors,
                scannedData,
                currentStore,
                toggleScanningModal,
              });
            }}
          />
        </div>
      )}
      <Modal
        show={addCustomerModal}
        size={customerToEdit?.isGuestCustomer ? "md" : "lg"}
        onHide={handleHideModal}
        animation={true}
        centered
        backdrop="static"
        className="add-inventory-modal"
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title className="d-flex w-100 justify-content-between">
            <span className="add-inventory-modal-header-name">
              {customerToEdit?.id && customerToEdit?.isGuestCustomer
                ? "Edit Guest Customer"
                : customerToEdit?.id
                ? "Edit Customer"
                : "New Customer"}
            </span>
            {isShowScanButton && (
              <div className="me-3">
                <Button
                  type="submit"
                  className="w-100"
                  label={buttonNameConstants.SCAN_ID}
                  handleClick={toggleScanningModal}
                ></Button>
              </div>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body ">
          <Formik
            initialValues={initialValues}
            validate={addCustomerValidationSchema}
            onSubmit={handleSubmit}
            innerRef={formikRef}
          >
            {({ resetForm, values, setFieldValue }) => (
              <Form className="">
                <Row className="m-0  p-0">
                  {customerToEdit?.isGuestCustomer ? (
                    <CustomerCreditAndSubmitButtons
                      user={user}
                      mdColSize={12}
                      resetForm={resetForm}
                      customerToEdit={customerToEdit}
                      handleHideModal={handleHideModal}
                    />
                  ) : (
                    <>
                      <PersonalInformation
                        values={values}
                        setFieldValue={setFieldValue}
                        setIsShowScanButton={setIsShowScanButton}
                      />
                      <Row className="p-0 mt-3">
                        <p className="form-portion-heading ">Address</p>
                        <Col md={6} className="mb-3 ">
                          <InputTextField
                            name="line1"
                            label="Street 1"
                            placeHolder="Enter Street 1"
                          />
                        </Col>
                        <Col md={6} className="mb-3 ">
                          <InputTextField
                            name="line2"
                            label="Street 2"
                            placeHolder="Enter Street 2"
                          />
                        </Col>
                        <Col md={6} className="mb-3 ">
                          <SelectFieldCity
                            cityValue={
                              values?.city
                                ? { value: values.city, label: values.city }
                                : ""
                            }
                          />
                        </Col>
                        <Col md={6} className="mb-3">
                          {/* <SelectFieldState /> */}
                          <SelectField
                            label="State"
                            name="state"
                            placeHolder={"Select State"}
                            options={customerConstants.STATE_OPTIONS}
                          />
                        </Col>
                        <Col md={6} className="mb-3  ">
                          <InputTextField
                            name="zip"
                            placeHolder="00000"
                            label="Zip"
                          />
                        </Col>
                      </Row>
                      <Row className="p-0 mt-3">
                        <Col md={6} className="mb-3 ">
                          <p className="form-portion-heading ">Notes</p>
                          <InputTextArea
                            maxLength={1500}
                            name="note"
                            placeHolder="Enter Note"
                          />
                        </Col>
                        <CustomerCreditAndSubmitButtons
                          user={user}
                          mdColSize={6}
                          resetForm={resetForm}
                          customerToEdit={customerToEdit}
                          handleHideModal={handleHideModal}
                        />
                      </Row>
                    </>
                  )}
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <ScanIdModal
        isScanning={isScanning}
        toggleScanningModal={toggleScanningModal}
      />
    </>
  );
};

// reducer
const mapStateToProps = (state) => ({
  store: state.store,
  customer: state.customer,
  user: state.authentication.user,
  isTransferCustomerCreditModal:
    state.transaction.isTransferCustomerCreditModal,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  logErrors: (data) => dispatch(logErrorsActions.logErrors(data)),
  addNewCustomer: (data) => dispatch(customerActions.addNewCustomer(data)),
  updateCustomer: (data) => dispatch(customerActions.updateCustomer(data)),
  toggleAddCustomerModal: (value) =>
    dispatch(transactionActions.toggleAddCustomerModal(value)),
  transferCustomerCredit: (data) =>
    dispatch(customerActions.transferCustomerCredit(data)),
});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddNewCustomerModal);
